const backendUrl = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8000';

export { backendUrl };
export default backendUrl;
